import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {LoadingButton} from '@mui/lab';
import {Box, Button, Typography} from '@mui/material';
import {useRef, useState} from 'react';

import AccessControl from '../../components/common/AccessControl';
import UserGroupItemUpsertButton from '../../components/user-groups/UserGroupItemUpsertButton';
import {
  UserGroupList,
  UserGroupListRef,
} from '../../components/user-groups/UserGroupList';
import {DashboardLayout} from '../../layouts/DashboardLayout';
import {Role} from '../../utils/acl';

const AdminUserGroupListPage = () => {
  const listRef = useRef<UserGroupListRef | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  return (
    <DashboardLayout>
      <AccessControl permissions={['get::/user-group']}>
        <Box
          display="flex"
          flexDirection="column"
          p={2}
          gap={0.5}
          height="100%"
          overflow="hidden"
        >
          <Box
            display="flex"
            gap={1}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              id="modal-modal-title"
              component="h1"
              variant="h5"
              sx={{mb: 2}}
            >
              Administration - User Groups
            </Typography>

            <Box
              display="flex"
              gap={1}
              alignItems="center"
              justifyContent="end"
            >
              <LoadingButton
                color="primary"
                loading={isRefreshing}
                sx={{p: 1, minWidth: 0}}
                onClick={async () => {
                  setIsRefreshing(true);
                  await listRef?.current?.fetch?.();
                  setIsRefreshing(false);
                }}
              >
                <RestartAltIcon />
              </LoadingButton>

              <LoadingButton
                color="primary"
                sx={{p: 1, minWidth: 0}}
                onClick={() =>
                  listRef.current?.dataGridRef.current?.printTable()
                }
              >
                <PrintIcon />
              </LoadingButton>

              <AccessControl
                roles={[Role.superUser, Role.strataManager]}
                permissions={['post::/user-group']}
              >
                <UserGroupItemUpsertButton
                  component={Button}
                  componentProps={{
                    variant: 'outlined',
                    startIcon: <AddIcon />,
                  }}
                  onSubmitted={() => listRef?.current?.fetch?.()}
                >
                  Add Group
                </UserGroupItemUpsertButton>
              </AccessControl>
            </Box>
          </Box>

          <UserGroupList ref={listRef} />
        </Box>
      </AccessControl>
    </DashboardLayout>
  );
};

export default AdminUserGroupListPage;
